<template>
  <div id="app">
    <upcoming-shows></upcoming-shows>
  </div>
</template>

<style lang="stylus">
#app
  font-family proxima-nova, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
  margin-top 60px
  
  h1, h2, h3, h4, h5, li, p, b, time
    font-family proxima-nova, Helvetica, Arial, sans-serif
</style>

<script>

import axios from 'axios'

import UpcomingShows from './components/UpcomingShows.vue'

export default {
  name: 'Upcoming',
  data(){
    return {
      times: {}
    }
  },
  components: {
    'upcoming-shows': UpcomingShows
  },
  async created(){
    try {
      const response = await axios.get('https://wowd-studio.creek.fm/api/times/test1')
      this.times = response.data
    }catch(error){
      console.log(error)
    }
  }
}
</script>